<script>
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Stocks from "@/components/modals/stocks.vue";
export default {
    name: "MergeStockModal",
    components: {
        MaskedInput,
        Stocks
    },
    props: {
        modalTitle: {
            type: String,
            default: "Merge Stock",
        },
    },
    data() {
        return {
            submitted: false,
            stockName: "",
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true
            }),
            form: {
                id: null,
                debit: 0,
                referenceNumber: "",
                stockItemId: null,
                stockName: "",
                unitCost: "",
                description: "",
                allowStockInput: false,
            },
        };
    },
    methods: {
        onMerge() {
            this.submitted = true;
            if (this.checkFormStock())  return;
            let data = JSON.parse(JSON.stringify(this.form));
            data.unitCost = this.getExactAmt(data.unitCost);
            this.$emit("submit", data);
        },
        checkFormStock() {
            if (
                this.form.referenceNumber === "" ||
                this.form.referenceNumber === null ||
                this.form.debit === "" ||
                this.form.debit === null
            ) {
                return true;
            } else return false;
        },
        getStocks() {
            this.$refs.stocks.getData();
            this.$bvModal.show("stocks-modal");
        },
        dropStocks(data) {
            this.form.stockItemId = data.id;
            this.stockName = data.name;
        },
        onReset(data, requisition){
            this.form = {
                id: null,
                debit: data.quantity,
                referenceNumber: requisition.poNumber,
                stockItemId: null,
                stockName: "",
                unitCost: data.unitCost.toString(),
                description: "",
                allowStockInput: data.stockItemId ? false : true,
                iarItemId: data.iarItemId,
            }
            this.stockName = data.stockName ? data.stockName : "";
        }
    },
};
</script>
<template>
    <b-modal
        id="merge-stock-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onMerge"
            class="needs-validation"
            ref="fcForm"
        >
            <div class="mb-3">
                Debit <span class="text-info">{{ form.debit }}</span> items
            </div>
            <div class="mb-3">
                <label for="referenceNumber">P.O. Number </label>
                <input
                    id="referenceNumber"
                    type="text"
                    v-model="form.referenceNumber"
                    placeholder="Enter PO Number..."
                    class="form-control"
                    :class="{
                    'is-invalid': submitted && form.referenceNumber == ''
                    }"
                    autocomplete="off"
                />
                <div
                    v-if="submitted && form.referenceNumber == ''"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div v-if="form.allowStockInput" class="mb-3">
                <label for="itemCategoryId">Stock </label>
                <b-input-group>
                    <template #append>
                    <b-button @click="getStocks" variant="outline-info"
                        ><i class="mdi mdi-clipboard-text-search-outline"></i
                    ></b-button>
                    </template>
                    <input
                    autocomplete="off"
                    type="text"
                    disabled
                    placeholder="Search Stock..."
                    class="form-control"
                    :class="{
                        'is-invalid': submitted && form.stockItemId == null
                    }"
                    v-model="stockName"
                    />
                </b-input-group>
                <div
                    v-if="submitted && form.stockItemId == null"
                    class="invalid-feedback"
                >
                    <span>This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="unitCost">Unit Cost </label>
                <masked-input
                    id="unitCost"
                    type="text"
                    v-model="form.unitCost"
                    placeholder="Enter Unit Cost..."
                    class="form-control"
                    :class="{
                    'is-invalid': submitted && form.unitCost == ''
                    }"
                    autocomplete="off"
                    :mask="currencyMask"
                ></masked-input>
            <div
                v-if="submitted && form.unitCost == ''"
                class="invalid-feedback"
            >
                <span>This value is required.</span>
            </div>
            </div>
            <div class="mb-3">
                <label for="description">Description </label>
                <textarea
                    id="description"
                    rows="4"
                    v-model="form.description"
                    placeholder="Enter Stock Description..."
                    class="form-control"
                    autocomplete="off"
                ></textarea>
            </div>
            <hr />
            <div class="d-flex flex-row-reverse">
                <button class="btn btn-primary" type="submit">Merge Item</button>
            </div>
        </form>
        <Stocks ref="stocks" @dropData="dropStocks($event)"></Stocks>
    </b-modal>
</template>